// Local color constants — only the keys actually used across the app that have
// no @cuemath/leap equivalent. For any leap-matching shade, use
// `theme.colors.<name>` in styled-components or the `TColorNames` string on
// leap component props instead of adding it here.

const toRGB = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : null;
};

export const toRGBA = (hex, alpha) => {
  const rgb = toRGB(hex);

  return rgb ? `rgba(${rgb.join(', ')}, ${alpha})` : null;
};

/** @type {any} */
const COLORS = {
  APPLE_2: '#149A53',
  ATHENS_GRAY_1: '#e2e4eb',
  BEIGE: '#fcf4e4',
  BRIGHT_GREEN: '#71DF96',
  FLOWER: '#ED6CEF',
  FLOWER_DARK: '#B038B2',
  FLOWER_XXLIGHT: '#FDEAFA',
  GRASS: '#3DD771',
  GRASS_DARK: '#149A53',
  GRASS_XLIGHT: '#AFE8C2',
  GRASS_XXLIGHT: '#DDFFE4',
  GREY_SHADOW: 'rgba(0, 0, 0, 0.12)',
  HEART: '#FF6782',
  HEART_DARK: '#E34C67',
  HEART_LIGHT: '#FF98C3',
  HEART_XDARK: '#BF2449',
  MUSTARD: '#ffcf56',
  ORANGE: '#FF7E3B',
  ORANGE_XLIGHT: '#FFC2A2',
  ORANGE_XXLIGHT: '#FFE9DD',
  PIG_PINK: '#FFE9DD',
  PRIMARY: '#0A47C2',
  PURPLE: '#850F85',
  RED: '#EA5959',
  SKY: '#1EB5F0',
  SKY_DARK: '#0A80D5',
  SKY_XDARK: '#0A47C2',
  SKY_XLIGHT: '#8DD5F1',
  SKY_XXLIGHT: '#ECF8FF',
  SUN: '#FFBA07',
  SUN_DARK: '#D68100',
  SUN_XLIGHT: '#FFDC83',
  VARDEN: '#FCF4E4',
};

export default COLORS;
